module.exports = __webpack_public_path__ + "img/avatar-helix.2eaa2bda.webp";